import { Box, Group, ScrollArea } from '@mantine/core';
import type { AiChatStore } from '../store';
import { Attachment } from './Attachment';

export function Attachments({ store }: { store: AiChatStore }) {
	return (
		<Box pt="xs">
			<ScrollArea>
				<Group h={52} spacing="3xs" noWrap>
					{store.attachments.map((attachment) => (
						<Attachment
							key={attachment.url}
							title={attachment.filename}
							href={attachment.url}
							onRemove={() => store.removeAttachment(attachment)}
						/>
					))}
				</Group>
			</ScrollArea>
		</Box>
	);
}
